import { observable } from "mobx"

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type ForeignLanguage = {
  name: string
  qualification_name: string
  qualification_score: string
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type ForeignLanguages = ForeignLanguage[]

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type StudentAchievements = {
  id: number
  name: string
  display: string
}[]

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type Skills = {
  name: string
}[]

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type RelatedLink = {
  title: string
  link: string
}

/**
 * @deprecated ~/api/student/profile/_types/ 内にある型をexportし、そちらを使用する
 * TODO(old-profile-page): 古いプロフィールの実装を消したらexportを消す
 */
export type RelatedLinks = RelatedLink[]
interface achievementsSkillArgs {
  foreign_language: ForeignLanguages
  student_achievements: StudentAchievements
  skills: Skills
  related_links: RelatedLinks
}

export class AchievementsSkill {
  @observable foreign_language: ForeignLanguages
  @observable student_achievements: StudentAchievements
  @observable skills: Skills
  @observable related_links: RelatedLinks

  constructor(args: achievementsSkillArgs) {
    this.foreign_language = args.foreign_language
    this.student_achievements = args.student_achievements
    this.skills = args.skills
    this.related_links = args.related_links
  }
}
